import React from 'react';
import classnames from 'classnames';
import moment from 'moment';
import Button from '../common/Button';
import styled from 'styled-components';
import { Link, Redirect } from 'react-router-dom';

const ButtonA = styled(Button)`
background: #324971;
color: #fff;
`;

class NewExamForm extends React.Component {

    state = {
        id: null
    }

    constructor(props) {
        super(props);
        this.state = {
            errors: {},
            loading: false,
            submitted: false,
            globalError: ''
        };
        //this.onSubmit = this.onSubmit.bind(this);
        //this.onChange = this.onChange.bind(this);
    }

    /* Pre-populate age and education years with logical options -- get previous values if on same day */

    componentWillReceiveProps = (nextProps) => {
        this.setState({
            id: nextProps.participant.Id,
            NoExams: nextProps.participant.NoExams,
            gender: nextProps.participant.Gender === "M" ? "Male" : "Female",
            age: nextProps.participant.Age,
            yearsEducation: nextProps.participant.YearsOfEducation,
            diagnosis: nextProps.participant.Diagnosis,
            diseaseSubtype: nextProps.participant.DiseaseSubtype,
            yearsDiagnosis: nextProps.participant.YearsSinceDiagnosis,
            countryExam: nextProps.participant.CountryExam,
            examLanguage: "",
            examNorms: "",
            errors: {},
            loading: false,
            submitted: false,
            // dates
            lastExamDate: nextProps.participant.LastExamDate,
            infoCorrectAsOf: nextProps.participant.InfoCorrectAsOf,
            centreNo: nextProps.participant.CentreNumber,

        });
    }

    handleSubmit = (e) => {
        e.preventDefault();

        // validation
        let errors = {};
        //if (this.state.gender === "0") errors.gender = "This is required";
        if (this.state.age === "0") errors.age = "This is required";
        if (this.state.yearsEducation === "0") errors.yearsEducation = "This is required";
        if (this.state.diagnosis === "0") errors.diagnosis = "This is required";
        if (this.state.diseaseSubtype === "0") errors.diseaseSubtype = "This is required";
        //if (this.state.yearsSinceDiagnosis === "0") errors.yearsSinceDiagnosis = "This is required";
        //if (this.state.centreNo !== "" && /^[0-9]{6,6}$/.test(this.state.centreNo) != true) errors.centreNo = "Please enter a 6 digit number";
        this.setState({ errors });
        const isValid = Object.keys(errors).length === 0;

        if (isValid) {
            //this.setState({ verification: true });
            const { id, NoExams, age, yearsEducation, diagnosis, diseaseSubtype, yearsDiagnosis, countryExam, examLanguage, examNorms } = this.state;
            this.setState({ loading: true });
            this.props.newExam({ id, NoExams, age, yearsEducation, diagnosis, diseaseSubtype, yearsDiagnosis, countryExam, examLanguage, examNorms }).then(
                (res) => this.setState({ loading: true, submitted: true, NoExams: res.exam.ExamNumber  }),
                (err) => this.setState({ globalError: "Could not start new exam", loading: false })
            );
            console.log('Form action completed - loading ' + this.state.loading);
            //.catch((err) => err.response.json().then(({errors}) => this.setState({ errors, loading: false })));
        }
    }

    handleChange = (e) => {
        if (!!this.state.errors[e.target.name]) {
            let errors = Object.assign({}, this.state.errors);
            delete errors[e.target.name];
            this.setState({
                [e.target.name]: e.target.value,
                errors
            });
        } else {
            this.setState({
                [e.target.name]: e.target.value
            });
        }
    }

    render() {
        //console.log(this.state);
        const form = ( 
        
        <div>

            <div className="row">
            <div className="col-md-12">
            <h1 className="bicamsColor"> Start new Exam </h1>  
			<h2 className="bicamsColor"> Verify Participant { this.state.id } Information </h2>  
			<h3 className="bicamsColor"> Information correct as of {
                this.state.lastExamDate !== null ?
                    moment(this.state.lastExamDate).format('DD-MMM-YYYY') :
                    this.state.infoCorrectAsOf !== null ?
                    moment(this.state.infoCorrectAsOf).format('DD-MMM-YYYY') :
                    'N/A'
            } </h3> 
			<p> <strong> Gender: </strong> {this.state.gender}</p >
            <p> <strong> Years Since Diagnosis: </strong> {this.state.yearsDiagnosis}</p >
            <p> <strong> Center Number: </strong> {this.state.centreNo !== null && this.state.centreNo !== '' ? this.state.centreNo : "N/A"}</p> </div> 
            </div>

            <div className="row">
            <div className="col-md-12">
            <form className={ classnames('ui', 'form', { loading: this.state.loading }) } onSubmit={ this.handleSubmit }>

            <div className="row">
            <fieldset className="col-sm-6">
            <legend>Demographic Information</legend>

            <div className={
                classnames('field',
                    //{ error: !!this.state.errors.age}
                )}>
            <select name="age"
            className="selectForm"
            onChange={ this.handleChange }>
            
<option value="0"> Current Age * </option> 
<option value="18"> 18 </option> 
<option value="19"> 19 </option> 
<option value="20"> 20 </option> 
<option value="21"> 21 </option> 
<option value="22"> 22 </option> 
<option value="23"> 23 </option> 
<option value="24"> 24 </option> 
<option value="25"> 25 </option> 
<option value="26"> 26 </option> 
<option value="27"> 27 </option> 
<option value="28"> 28 </option> 
<option value="29"> 29 </option> 
<option value="30"> 30 </option> 
<option value="31"> 31 </option> 
<option value="32"> 32 </option> 
<option value="33"> 33 </option> 
<option value="34"> 34 </option> 
<option value="35"> 35 </option> 
<option value="36"> 36 </option> 
<option value="37"> 37 </option> 
<option value="38"> 38 </option> 
<option value="39"> 39 </option> 
<option value="40"> 40 </option> 
<option value="41"> 41 </option> 
<option value="42"> 42 </option> 
<option value="43"> 43 </option> 
<option value="44"> 44 </option> 
<option value="45"> 45 </option> 
<option value="46"> 46 </option> 
<option value="47"> 47 </option> 
<option value="48"> 48 </option> 
<option value="49"> 49 </option> 
<option value="50"> 50 </option> 
<option value="51"> 51 </option> 
<option value="52"> 52 </option> 
<option value="53"> 53 </option> 
<option value="54"> 54 </option> 
<option value="55"> 55 </option> 
<option value="56"> 56 </option> 
<option value="57"> 57 </option> 
<option value="58"> 58 </option> 
<option value="59"> 59 </option> 
<option value="60"> 60 </option> 
<option value="61"> 61 </option> 
<option value="62"> 62 </option> 
<option value="63"> 63 </option> 
<option value="64"> 64 </option> 
<option value="65"> 65 </option>
</select>
<span></span>
</div>

            <div className={classnames('field',
                    //{ error: !!this.state.errors.yearsEducation}
                )}>
            <select name="yearsEducation" className="selectForm" onChange={ this.handleChange }>
            
<option value="0">Years of Education *</option> 
<option value="1"> 1 </option> 
<option value="2"> 2 </option> 
<option value="3"> 3 </option> 
<option value="4"> 4 </option> 
<option value="5"> 5 </option> 
<option value="6"> 6 </option> 
<option value="7"> 7 </option> 
<option value="8"> 8 </option> 
<option value="9"> 9 </option> 
<option value="10"> 10 </option> 
<option value="11"> 11 </option> 
<option value="12"> 12 </option> 
<option value="13"> 13 </option> 
<option value="14"> 14 </option> 
<option value="15"> 15 </option> 
<option value="16"> 16 </option> 
<option value="17"> 17 </option> 
<option value="18"> 18 </option> 
<option value="19"> 19 </option> 
<option value="20"> 20 </option> 
</select>
<span></span>
</div>

            </fieldset>    

            <fieldset className="col-sm-6">
            <legend>Clinical Information</legend>

            <div className={
                classnames('field',
                    //{ error: !!this.state.errors.diagnosis}
                )
            } >
            <select name="diagnosis"
            className="selectForm"
            onChange={ this.handleChange } >
            
<option value="">Diagnosis *</option> 
<option value="Definite CIS/MS">Definite CIS / MS</option> 
<option value="Possible CIS/MS">Possible CIS / MS</option>
</select>
<span></span>
</div>


            <div className={
                classnames('field',
                    //{ error: !!this.state.errors.diseaseSubtype}
                )
            } >
            <select name="diseaseSubtype"
            className="selectForm"
            onChange={ this.handleChange } >
            
<option value="">Disease sub - type *</option> 
<option value="CIS"> CIS </option> 
<option value="RR"> RR </option> 
<option value="SP"> SP </option> 
<option value="PP"> PP </option>
</select>
<span></span>
</div>

            <div className={
                classnames('field',
                    //{ error: !!this.state.errors.diseaseSubtype}
                )
            } >
            <select name="examCountry"
            className="selectForm"
            onChange={ this.handleChange } >
            
<option value="">Country of Exam *</option> 
<option value="USA"> United States </option> 
<option value="GBR"> United Kingdom </option>
</select>
<span></span>
</div>

            <div className={classnames('field',
                    //{ error: !!this.state.errors.diseaseSubtype}
                )
            } >
            <select name="examLanguage" className="selectForm" onChange={ this.handleChange }>
            
<option value="">Language of Exam *</option> 
<option value="EN-GB"> English - United Kingdom </option>
</select>
<span></span>
</div>

            <div className={
                classnames('field',
                    //{ error: !!this.state.errors.diseaseSubtype}
                )
            } >
            <select name="examNorms"
            className="selectForm"
            onChange={ this.handleChange } >
            
<option value=""> Norms to be Applied * </option> 
<option value="USA"> United States </option>
</select>
<span></span>
</div>


            </fieldset>
            </div>

            <div className="field">
            <ButtonA className="btn btn-lg">Submit</ButtonA>

        Fields marked with a * are mandatory 
        </div>

            </form>
            </div></div></div>
        );

        const confirmMessage = ( 
            
            <div className="row">

            <div className="col-md-12">        
            <h1 className="bicamsColor">Exam created</h1> 
            <h2>BICAMS Exam NUMBER: { this.state.NoExams } </h2>

            <Link to="/app_sync"> <ButtonA className="btn btn-lg"> Sync </ButtonA></Link >
             </div>

            </div>
           

        );

        const confirmRedir= ( 
            <Redirect to='/app_sync' />
        );



        return (
            this.state.submitted ? confirmRedir : form
        );

    }
}

export default NewExamForm;


// WEBPACK FOOTER //
// ./src/components/exam/NewExamForm.js